import React, { useState, useEffect } from 'react';
import { Html } from '@react-three/drei';
import { getSocket } from '../socket.js';

const socket = getSocket();
import { useAtom, useAtomValue } from 'jotai';
import { audioVolumeAtom, clientAtom, joinTeamAtom, teamsAtom, languageAtom } from '../GlobalState';
import { trackEvent } from '../api';
import useSoundEffectsPlayer from '../soundPlayers/useSoundEffectsPlayer';
import translations from '../dictionaries/translations.js';

export default function JoinTeamModal({ position, rotation, scale }) {

  const [name, setName] = useState('')
  const [alert, setAlert] = useState('')
  const [submitHover, setSubmitHover] = useState(false)
  const [cancelHover, setCancelHover] = useState(false)
  const [joinTeam, setJoinTeam] = useAtom(joinTeamAtom)
  const client = useAtomValue(clientAtom)
  const teams = useAtomValue(teamsAtom)
  const { playSoundEffect } = useSoundEffectsPlayer()
  const audioVolume = useAtomValue(audioVolumeAtom) // default sound off
  const language = useAtomValue(languageAtom)
  
  function isValidPlayerName(value) {
    return /^[\p{L}\p{N} ]+$/u.test(value)
  }

  function isUniqueName(name, team) {
    for (let i = 0; i < team.players.length; i++) {
      if (team.players[i].name.toUpperCase() === name.toUpperCase()) {
        return false;
      }
    }
    return true;
  }

  async function joinTeamHandler(joinTeam, name) {
    setAlert("")
    socket.emit("joinTeam", { team: joinTeam, name }, ({ player }) => {
      if (player) { // refactor into mongodb stream
        // const audio = new Audio('sounds/effects/join-2.mp3');
        // audio.volume = 1;
        // audio.play();
        setName('')
        setSubmitHover(false)
        setJoinTeam(null);
      }
    });
      
    playSoundEffect('/sounds/effects/door-chime.mp3', audioVolume)

    await trackEvent({ surface: 'lobby', action: 'join_team', category: 'gameplay', metadata: { team: joinTeam } })
  }

  async function handleJoinSubmit(e) {
    e.preventDefault();
    if (name.length == 0) {
      setAlert('Enter something')
    } else if (client.team === -1 && (!isUniqueName(name, teams[0]) || !isUniqueName(name, teams[1]))) {
      setAlert('Another player has the same name.')
    } else if (client.team !== -1 && joinTeam !== client.team) { // switching teams
      if (name.toUpperCase() === client.name.toUpperCase()) { // allow
        await joinTeamHandler(joinTeam, name)
      } else if (!isUniqueName(name, teams[0]) || !isUniqueName(name, teams[1])) {
        setAlert('Another player has the same name.')
      } else {
        await joinTeamHandler(joinTeam, name)
      }
      // case: clicked an open seat to switch names
    } else if (name.length > 15) {
      setAlert('Must be shorter than 16 characters.')
    } else if (!isValidPlayerName(name)) { // prevent user from imitating host by adding '(host)'
      setAlert('Can only contain letters and numbers.')
    } else {
      await joinTeamHandler(joinTeam, name)
    }
  }
  
  function handleJoinCancel(e) { // submits name and emits 'joinTeam'
    e.stopPropagation()
    e.preventDefault()
    setName('')
    setJoinTeam(null);
    setAlert('');
    setCancelHover(false)
    return false;
  }

  function handleSubmitMouseEnter () {
    setSubmitHover(true)
  }
  function handleSubmitMouseLeave () {
    setSubmitHover(false)
  }
  function handleCancelMouseEnter () {
    setCancelHover(true)
  }
  function handleCancelMouseLeave () {
    setCancelHover(false)
  }

  
  const modalFont = language === 'korean'
    ? "'MaplestoryLight', 'Noto Sans SC', sans-serif"
    : "'Luckiest Guy', 'Noto Sans SC', sans-serif"
  const nameFont = /[\u3400-\u9fff\uf900-\ufaff]/u.test(name)
    ? "'Noto Sans SC', sans-serif"
    : modalFont

  const [lastJoinTeam, setLastJoinTeam] = useState(joinTeam)
  useEffect(() => {
    if (joinTeam !== null) {
      setLastJoinTeam(joinTeam)
    }
  }, [joinTeam])

  if (lastJoinTeam === null) return null

  // fix HTML to threejs for all except the input placeholder
  return <group 
    position={position}
    rotation={rotation}
    scale={scale}
  >
    <Html transform>
      <div style={{ position: 'absolute' }}>
        <form onSubmit={e => handleJoinSubmit(e)}>
          <div style={{
            top: '40%',
            width: '155px',
            backgroundColor: 'black',
            border: '2px solid #F1EE92',
            padding: '10px'
          }}>
            <p style={{
              fontFamily: modalFont,
              color: '#F1EE92',
              fontSize: '15px',
              padding: '5px',
              margin: '0px',
              textAlign: 'center'
            }}>
              {translations.lobby.joinTheRockets[language]} {lastJoinTeam === 0 ? <span style={{ color: '#FF5030' }}>{translations.lobby.rockets[language]}</span> : <span style={{ color: 'turquoise' }}>{translations.lobby.ufos[language]}</span>} {translations.lobby.as[language]}
            </p>
            <input
              style={{
                width: `142px`,
                background: 'none',
                fontFamily: nameFont,
                fontSize: `15px`,
                color: '#F1EE92',
                padding: '5px',
                border: '2px solid #F1EE92'
              }}
              onChange={e => setName(e.target.value)}
              placeholder={translations.lobby.namePlaceholder[language]}/>
            <div>
              <p style={{ margin: '5px', color: 'red', fontFamily: modalFont, fontSize: '10px' }}>
                {alert}
              </p>
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center'
            }}>
              <button 
                id='join-team-submit-button'
                style={{
                  fontFamily: modalFont,
                  fontSize: `15px`,
                  background: 'none',
                  border: `2px solid ${submitHover ? 'white' : '#F1EE92'}`,
                  margin: '5px',
                  padding: '5px',
                  color: `${submitHover ? 'white' : '#F1EE92'}`,
                  position: 'relative'}}
                onMouseOver={handleSubmitMouseEnter}
                onMouseOut={handleSubmitMouseLeave}
                type="submit">
                {translations.lobby.leggo[language]}
              </button>
              {/* highlight on hover */}
              <button 
                id='join-team-cancel-button'
                style={{
                  fontFamily: modalFont,
                  fontSize: `15px`,
                  background: 'none',
                  border: `2px solid ${cancelHover ? 'white' : 'red'}`,
                  margin: '5px',
                  padding: '5px',
                  color: `${cancelHover ? 'white' : 'red'}`,}}
                onMouseOver={handleCancelMouseEnter}
                onMouseOut={handleCancelMouseLeave}
                onClick={e => handleJoinCancel(e)}
                // need this to stop form from submitting
                type="button">
              {translations.lobby.nah[language]}
              </button>
            </div>
          </div>
        </form>
      </div>
    </Html>
  </group>
}